import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import ContactForm from '../components/ContactForm';
import './Contact.css';

const DAY = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function formatTime(t) {
  if (!t) return '';
  const [hStr, mStr] = t.split(':');
  let h = parseInt(hStr, 10);
  const m = parseInt(mStr || '0', 10);
  if (Number.isNaN(h)) return t;
  const suffix = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return m === 0 ? `${h} ${suffix}` : `${h}:${String(m).padStart(2, '0')} ${suffix}`;
}

export default function Contact() {
  const [info, setInfo] = useState(null);
  const [services, setServices] = useState([]);

  const [searchParams] = useSearchParams();
  const slugFromUrl = searchParams.get('service');

  const preferredServiceName = useMemo(() => {
    if (!slugFromUrl) return '';
    return services.find((s) => s.slug === slugFromUrl)?.name || '';
  }, [slugFromUrl, services]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/business-info`).then((r) => r.ok ? r.json() : null).then(setInfo).catch(() => {});
    fetch(`${API_BASE_URL}/api/services`).then((r) => r.ok ? r.json() : []).then(setServices).catch(() => setServices([]));
  }, []);

  return (
    <main className="contact-main">
      <h1>Contact</h1>
      <div className="contact-grid">
        <div className="contact-form-col">
          <p className="contact-lead">Send a message and I'll get back to you within a day.</p>
          <ContactForm services={services} initialPreferredService={preferredServiceName} />
        </div>
        <aside className="contact-info-col">
          {info?.phone && <div><div className="contact-label">Phone</div><div>{info.phone}</div></div>}
          {info?.email && <div><div className="contact-label">Email</div><div>{info.email}</div></div>}
          {(info?.addressLine1 || info?.city) && (
            <div>
              <div className="contact-label">Address</div>
              <div>
                {info.addressLine1}
                {info.addressLine2 && <><br/>{info.addressLine2}</>}
                {info.city && <><br/>{info.city}{info.state ? `, ${info.state}` : ''} {info.postalCode || ''}</>}
              </div>
            </div>
          )}
          {info?.hours?.length > 0 && (
            <div>
              <div className="contact-label">Hours</div>
              <table className="contact-hours">
                <tbody>
                  {[1,2,3,4,5,6,0].map((d) => {
                    const h = info.hours.find((x) => x.dayOfWeek === d) || { isOpen: false };
                    const time = h.isOpen ? `${formatTime(h.openTime)}–${formatTime(h.closeTime)}` : 'Closed';
                    return (
                      <tr key={d}>
                        <td>{DAY[d]}</td>
                        <td>{time}{h.note ? <span className="contact-hours-note"> ({h.note})</span> : null}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          {info?.mapEmbedUrl && (
            <div className="contact-map">
              <iframe src={info.mapEmbedUrl} title="Map" width="100%" height="260" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
          )}
        </aside>
      </div>
    </main>
  );
}
